import { IPendencySimulationsRepository } from 'modules/customer/domain/repositories';
import {
  IVectisPendencySimulation,
  PendencySimulation,
} from 'modules/customer/infra/adapters';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';

export default class VectisPendencySimulationsRepository
  implements IPendencySimulationsRepository
{
  constructor(private httpProvider: IHTTPProvider) {}

  public findAll: IPendencySimulationsRepository['findAll'] = async ({
    customerId,
    unitId,
    accounts,
  }) => {
    const { parcelamento } = await this.httpProvider.post<{
      parcelamento: IVectisPendencySimulation[];
    }>(`/clientes/${customerId}/condicoesParcelas`, {
      idUnidade: unitId,
      contas: accounts,
    });

    return parcelamento.map(parcela => new PendencySimulation(parcela));
  };
}
